import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="send-relevant-content"
export default class extends Controller {
  static targets = ["checkbox", "hiddenInputsContainer", "continueButton"]

  selectedPostIds = new Set()

  checkboxTargetConnected(element) {
    element.checked = this.selectedPostIds.has(element.value)
  }

  togglePost(event) {
    const checkbox = event.currentTarget
    const postId = checkbox.value

    if (checkbox.checked) {
      this.selectedPostIds.add(postId)
    } else {
      this.selectedPostIds.delete(postId)
    }

    this.updateHiddenInputs()
    this.updateContinueButton()
  }

  updateHiddenInputs() {
    const container = this.hiddenInputsContainerTarget
    container.innerHTML = ""

    this.selectedPostIds.forEach(postId => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "send_relevant_content[post_ids][]"
      input.value = postId
      container.appendChild(input)
    })
  }

  updateContinueButton() {
    this.continueButtonTarget.disabled = this.selectedPostIds.size === 0
  }
}
